<template>
	<div class="tab-pane-snapshot-wrapper">
		<!-- блок с локальным сообщением об ошибке -->
		<transition name="fadeControl" key="transitionError">
			<div v-show="localErrorMessage !== ''" class="alert alert-danger margin-20-0" role="alert">
				<button @click="localErrorMessage = ''" class="close" :title="'main/close' | ftc">×</button>
				<span style="padding:0;margin:0;" v-withSafeTags="localeFtc(localErrorMessage)"></span>
			</div>
		</transition>

		<!-- доп.информация -->
		<div class="w5-form-additional-info" style="margin-right: 0; margin-top: 15px">
			<!-- кнопка создания -->
			<div class="w5-form-row js-end" :class="{ 'with-table': cacheData && cacheData.length }">
				<div class="btn btn-submit font-weight-300" @click="createForm" :disabled="!Access ? 'disabled' : false">{{ 'service/extdisk_create' | ftc }}</div>
			</div>
		</div>
		<br>
		

		<!-- таблица -->
		<table class="w5-snapshot-table margin-top-5">
			<thead>
				<tr>
					<th class="w5-tab-table-th-0">
						<span v-if="cacheData">{{ 'service/extdisk' | ftc }}</span>
					</th>
					<th class="w5-tab-table-th-1">
						<span v-if="cacheData">{{ 'service/extdisk_attached' | ftc }}</span>
					</th>
					<th class="w5-tab-table-th-2">
						<span v-if="cacheData">{{ 'main/status' | ftc }}</span>
					</th>
					<th class="w5-tab-table-th-3">
						<span v-if="cacheData">{{ 'main/created' | ftc }}</span>
					</th>
					<!-- колонка операций над строкой -->
					<th class="w5-column-opers" style="width: 45px">&nbsp;</th>
				</tr>
			</thead>
			<tbody>
				<template v-if="cacheData && cacheData.length">
					<tr v-for="row in cacheData" :key="row['service_id']">
						<td :aria-label="'service/extdisk' | ftc">
							<span class="w5-table-cell" :class="{ 'w5-link': Access && !row['Status']['loader'] && !row['Status']['timer'] }" @click.stop="updateForm(row['service_id'], row)">
								{{ row['service_name_full'] | ftc }}
							</span>
						</td>
						<td :aria-label="'service/extdisk_attached' | ftc">
							<div class="w5-list-iso">
								<template v-if="row['service_data'] && row['service_data']['extdisk'] && row['service_data']['extdisk']['attached'] === true">
										<button v-if="!row['service_status_text']" class="btn btn-default w5-eject-iso-button" :title="'main/detach' | ftc" @click="ejectOuterDisk(row, $event)">
											<font-awesome-icon icon="eject" />
										</button>
										<div v-if="String(row['parent_id']) !== vdsId" style="margin-left: 5px" class="hidden-ellipsis"><linkComponent :url="'/vds/view/' + row['parent_id']" :text="row['parent_name']"></linkComponent></div>
										<div v-else class="hidden-ellipsis" style="margin-left: 5px"><span v-if="row['service_data']['extdisk']['device']">{{ row['service_data']['extdisk']['device'] }}</span><span v-else>{{ row['parent_name'] }}</span></div>
								</template>
								<span v-else>{{ 'main/no' | ftc | lower }}</span>
							</div>
						</td>
						<td :aria-label="'main/status' | ftc">
							<span class="w5-table-cell">
								<span v-if="row['Status']['loader']" class="margin-right-10" :class="'w5-status-color-' + row['service_status']" style="white-space: normal">{{ row['Status']['status'] | lower }} <img src="../../assets/img/loading-hor16.gif" style="margin-left: 6px" /></span>
								<span v-else-if="row['Status']['timer']" class="margin-right-10" :class="'w5-status-color-' + row['service_status']" style="white-space: normal">{{ row['Status']['status'] | lower }} <font-awesome-icon icon="clock" style="margin-left: 6px" /></span>
								<span v-else class="margin-right-10" :class="'w5-status-color-' + row['service_status']" style="white-space: normal">{{ row['Status']['status'] | lower }}</span>
							</span>
						</td>
						<td :aria-label="'main/created' | ftc" style="text-align: center">
							<span class="w5-table-cell">
								{{ formater_StrDateFormat(row['service_created'], 'd.m.Y') }}
							</span>
						</td>
						<td>
							<!-- для мобил -->
							<div v-if="$store.state.windowWidth <= 767" class="w5-opers-button-for-mobile">
								<!-- кнопка удаления -->
								<div v-if="Access && !row['Status']['loader'] && !row['Status']['timer']"
									@click.stop="deleteAction(row['service_id'], row)"
									class="w5-opers-button-curd-btn">
									<font-awesome-icon icon="trash-alt" class="color-red" style="font-size: 16px" />
								</div>
							</div>
							<!-- для десктопов -->
							<div v-else-if="$store.state.windowWidth > 767 && thereAreItems(row)"
								:class="{ 'w5-opers-button-opened': row['__btnShow'] }"
								class="btn-group w5-opers-button"
								:data-id="row['id']"
								@click.stop="toggleMenu(row)">
								<!-- сама кнопка -->
								<span class="dropdown-toggle">
									<font-awesome-icon icon="bars" /> <span class="caret"></span>
								</span>
								<!-- пункты меню -->
								<ul v-show="row['__btnShow']" class="dropdown-menu" role="menu" @click.stop :style="cssUl">

									<!-- кнопка подключения -->
									<li v-if="Access && !row['Status']['loader'] && !row['Status']['timer'] && canConnectDisk(row)"
										@click.stop="insertDisk(row)">
										<font-awesome-layers class="w5-dropdown-menu-item w5-opers-button-other-btn">
											<font-awesome-icon icon="hdd" />
											{{ 'main/attach main/disk' | ftc | capitalize }}
										</font-awesome-layers>
									</li>

									<!-- кнопка отключения -->
									<li v-if="Access && !row['Status']['loader'] && !row['Status']['timer'] && !canConnectDisk(row)"
										@click.stop="ejectOuterDisk(row, $event)">
										<font-awesome-layers class="w5-dropdown-menu-item w5-opers-button-other-btn">
											<font-awesome-icon icon="eject" />
											{{ 'main/detach main/disk' | ftc | capitalize }}
										</font-awesome-layers>
									</li>

									<li v-if="Access && !row['Status']['loader'] && !row['Status']['timer']" class="divider"></li>

									<!-- кнопка удаления -->
									<li v-if="Access && !row['Status']['loader'] && !row['Status']['timer']"
										@click.stop="deleteAction(row['service_id'], row)">
										<span class="w5-dropdown-menu-item w5-opers-button-other-btn">
											<font-awesome-icon icon="trash-alt" class="color-red" />
											{{ 'main/delete' | ftc }}
										</span>
									</li>
								</ul>
							</div>
						</td>
					</tr>
				</template>
				<tr v-else>
					<td colspan="4" class="text-center">
						<img src="../../assets/img/puzzle.png" class="w5-empty-table-img" />
						<br>
						<span class="font-size-110 w5-empty-table-hint">{{ 'main/empty_table' | ftc }}</span>
					</td>
				</tr>				
			</tbody>
		</table>



		<!-- диалог создания/редактирования -->
		<transition name="modal">
			<div v-show="showFormModal" @mousedown="maskModalFlag = true" @mouseup="() => this.hideFormModal(false)" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container modal-form" id="modal-form" @mousedown="onModalMouse" @mouseup="onModalMouse">

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ formModalTitle | ftc }}</span>
							<button type="button" class="close" @click="hideFormModal">&times;</button>
						</div>

						<!-- если это подтверждение -->
						<template v-if="formMode === 'updateConfirm'">
							<div class="modal-body">
								<p class="padding-0-5" v-withSafeTags="localeFtc(formConfirmText)"></p>
							</div>
						</template>
						<!-- если это форма -->
						<template v-else>
							<!-- тело диалога -->
							<div v-if="form && form.fields" class="modal-body">
								<!-- информация о стоимости -->
								<div v-if="showAdditionalInfo" class="w5-form-additional-info">
									<span v-if="formInfo.max" class="pull-left">{{ 'main/available_to_order' | ftc }}: <strong>{{ formInfo.max }}</strong><span v-if="formInfo.for"> {{ formInfo.for | ftc }}</span></span>
									<span v-if="formInfo.cost" class="pull-right">{{ 'servicetype/cost' | ftc }}: <strong>{{ formInfo.cost }}</strong> <span v-withSafeTags="localeFtc('main/ruble')"></span><span v-if="formInfo.period"> / {{ formInfo.period | ftc }}</span><span v-if="formInfo.for"> / 1 {{ formInfo.for | ftc }}</span></span>
									<span class="clearfix"></span>
								</div>
								<!-- форма редактирования -->
								<form class="w5-from">
								<fieldset :disabled="form_Loading">

									<!-- поля -->
									<div v-for="(row, index) in form.fields" :key="index" :class="{ 'w5-form-row': isVisibleField(row) }">
										<template v-if="row">
											<Field v-for="field in row"
												:key="field._field_name"
												:isVisibleRow="isVisibleField(row)"
												:fieldInModal="true"
												:action="formMode"
												:Field="field"
												:listBlockToOut="1"
												:diskTypeValue="field._field_name === 'quantity' ? diskType : null"
												crud="disks"
												v-model="field.value"
												@dragStart="onDragStart"
												@dragEnd="onDragEnd"
												@outerDiskTypeChanged="onDiskTypeChanged"
												@valueChanged="fieldChanged(field)" />
										</template>
									</div>

								</fieldset>
								</form>
							</div>
						</template>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit pull-right" :disabled="form_Loading" @click="formModalBegin">{{ formMode === 'create' ? 'main/create' : formMode === 'update' ? 'main/save' : 'main/continue' | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>

		

		<!-- диалог удаления -->
		<transition name="modal">
			<div v-show="showDeleteModal" @click="hideDeleteModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ 'service/extdisk' | ftc }}</span>
							<button type="button" class="close" @click="hideDeleteModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body">
							<p class="padding-0-5" v-withSafeTags="localeFtc(deleteModalText)"></p>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit btn-submit-danger pull-right" :disabled="deleteModalTimer && deleteModalTimer > 0 ? 'disabled' : false" @click="deleteBackupBegin">{{ modalDeleteButtonTitle }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>



		<!-- диалог детача -->
		<transition name="modal">
			<div v-show="showModal" @click="hideModal" class="modal-mask">
				<div class="modal-wrapper">
					<div class="modal-container" @click.stop>

						<!-- заголовок -->
						<div class="modal-header">
							<span class="font-weight-500">{{ modalTitle | ftc }}</span>
							<button type="button" class="close" @click="hideModal">&times;</button>
						</div>

						<!-- тело диалога -->
						<div class="modal-body">
							<p class="padding-0-5" v-withSafeTags="localeFtc(modalText)"></p>
						</div>

						<!-- подвал -->
						<div class="modal-footer">
							<span class="btn btn-submit pull-right" :class="{ 'btn-submit-danger': modalButtonTitle.indexOf(localeFtc('main/detach')) > -1 }" :disabled="modalTimer && modalTimer > 0 ? 'disabled' : false" @click="diskProcessBegin">{{ modalButtonTitle | ftc }}</span>
						</div>
					</div>
				</div>
			</div>
		</transition>



	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import $ from 'jquery'
import Helper from '@/helper/helper'
import { EventBus } from '@/bus.js'
import Field from '@/components/elements/formfield'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'tabDisks',
	//=========================================================================
	// данные переденные родителем
	//=========================================================================
	props: [
		'active',
		'vdsId',
		'vdsName',
		'account',
		'dc',
		'access',
		'serviceStatus',
		'parentError'
	],
	//=========================================================================
	// вычисляемые свойства
	//=========================================================================
	computed: {
		// кнопка на модальном диалоге удаления
		modalDeleteButtonTitle() {
			if (!this.deleteModalTimer || this.deleteModalTimer <= 0) return this.localeFtc('main/delete')
			return this.localeFtc('main/delete_timer').replace('{count}', this.deleteModalTimer)
		},
		// заголовок диалога создания/правки
		formModalTitle() {
			if (this.form && this.form.title) return this.form.title
			return this.formMode === 'create' ? 'service/create_title' : 'service/update_title'
		},
		// видимость дополнительной информации
		showAdditionalInfo() {
			// показываем только клиентам
			if (this.$store.state.user_type !== 'client') return false
			// если нет данных вообще
			if (!this.formInfo || typeof this.formInfo !== 'object' || !Object.keys(this.formInfo).length) return false
			// если это массив - это не то
			if (Array.isArray(this.formInfo)) return false
			// если нет ни максимального значения, ни стоимости вообще
			if (!('max' in this.formInfo) && !('cost' in this.formInfo.max)) return false
			// если максимальное значение больше бесконечности
			if (this.formInfo.max >= 100000) return false

			// в остальных случаях показываем
			return true
		}
	},
	//=========================================================================
	// переменные
	//=========================================================================
	data() {
		return {
			localErrorMessage: '',
			// закешированный список
			cacheData: null,
			// доступ к VDS
			Access: false,
			Error: '',

			// диалог создания/парвки
			showFormModal: false,
			formMode: 'create',
			form: null,
			formId: null,
			formParentID: null,
			formSavedFields: null,
			formInfo: null,
			formConfirmText: '',
			diskType: '17',

			// диалог удаления записи
			showDeleteModal: false,
			deleteModalText: '',
			deleteModalTimer: false,
			deleteModalTimerHandle: false,
			deleteID: null,

			// данные в виде FormData
			FD: false,
			FD_count: 0,

			// расчитанный стиль пунктов меню строки
			cssUl: false,

			// слайдер двигают или нет
			isSliderDraging: false,

			// диалог детача/атча диска
			showModal: false,
			modalTitle: 'service/extdisk',
			modalText: '',
			modalTimer: 0,
			modalTimerHandler: null,
			modalButtonTitle: '',

			// список текущих запросов по reloadif
			reloadifRequests: {}
		}
	},
	//=========================================================================
	// компонент создан
	//=========================================================================
	created() {
		this.Access = this.access
		this.Error = this.parentError

		this.maskModalFlag = false
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		// навешиваем обработчик на нажатие клавиш
		document.addEventListener('keydown', this.keyDownHandler)
		document.addEventListener('click', this.clickHandler)
		// подписка на Push-сообщения
		EventBus.$on('w5-push', this.pushMessageHandler)
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		// обработчики
		document.removeEventListener('keydown', this.keyDownHandler)
		document.removeEventListener('click', this.clickHandler)
		// отписка от Push-сообщений
		EventBus.$off('w5-push', this.pushMessageHandler)

		// если активен таймер удаления
		if (this.deleteModalTimerHandle)
		{
			clearInterval(this.deleteModalTimerHandle)
			this.deleteModalTimerHandle = false
		}

		// если активен таймер блокировки
		if (this.modalTimerHandler)
		{
			clearInterval(this.modalTimerHandler)
			this.modalTimerHandler = null
		}
	},
	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// есть ли пункты в меню строки
		//---------------------------------------------------------------------
		thereAreItems(row) {
			let _isRestore = this.Access && !row['Status']['loader'] && !row['Status']['timer']
			let _isRemove = this.Access && !row['Status']['loader'] && !row['Status']['timer']

			return _isRestore || _isRemove
		},
		//---------------------------------------------------------------------
		// обработка клавиш
		//---------------------------------------------------------------------
		keyDownHandler(e) {
			// закрытие диалогов
			if (e.keyCode === 27 && this.active)
			{
				e.preventDefault()

				this.hideFormModal()
				this.hideDeleteModal()
				this.hideModal()

				this.clickHandler()
			}
		},
		//---------------------------------------------------------------------
		// обработка кликов по документу
		//---------------------------------------------------------------------
		clickHandler(e) {
			if (this.cacheData && this.cacheData.length)
				this.cacheData.forEach(item => (item['__btnShow'] = false))
		},
		//---------------------------------------------------------------------
		// получение списка
		//---------------------------------------------------------------------
		requestData() {
			if (!this.dc || !this.dc.id) return

			const _url = '/service/list'
			const _getParams = {
				ServiceSearch: {
					service_type_id: '16,17',
					datacenter_id: this.dc.id
				}
			}

			// если это сотрудник - фильтр по аккаунту
			if (this.$store.state.user_type === 'admin') {
				if (this.account && this.account.account_id) {
					// this.$store.state.accountGlobalFilter
					_getParams['ServiceSearch']['account_id'] = this.account.account_id.value
				}
			}

			this.forms_Get(_url, _getParams,
				(data) => {
					if (!data || data['status'] !== 'ok' || !data['columns'] || !data['rows'] || !data['rows'].length) {
						this.cacheData = null
						return
					}

					this.cacheData = []
					for (let i = 0; i < data['rows'].length; i++)
					{
						// фильтр по подключенному серверу
						if (data['rows'][i]['service_data'] &&
							data['rows'][i]['service_data']['extdisk'] &&
							data['rows'][i]['service_data']['extdisk']['attached']) {
							// подключен - смотрим по parent_id к кому
							if (String(data['rows'][i]['parent_id']) !== String(this.vdsId)) {
								continue
							}
						}

						// получим строку
						let _row = Object.assign({}, data['rows'][i])
						// добавим свой статус
						_row['Status'] = this.Status(data['rows'][i])
						// добавим признак - показ кнопки
						_row['__btnShow'] = false

						// добавим
						this.cacheData.push(_row)
					}
				},
				// ошибка при запросе данных
				() => {
					this.cacheData = null
				}
			)
		},
		//---------------------------------------------------------------------
		// обработчики Push-сообщений
		//---------------------------------------------------------------------
		pushMessageHandler(msg) {
			// проверка - не задано само сообщение
			if (!msg) return
			// вкладка не активна
			if (!this.active) return

			if (!this.cacheData || !Array.isArray(this.cacheData) || !this.cacheData.length) return

			// разобъем сообщение на части
			let _parts = msg.split(' ')

			// проверка корректности
			if (!_parts || _parts.length < 3) return

			// сообщение нужно обработать только если совпадает CRUD
			if (_parts[1] !== 'service') return

			// получим ID
			let _id = _parts[2]
			// если не задан ID - ничего не делаем
			if (!_id) return

			// может быть это ID нашего VDS?
			let _isVds = String(this.vdsId) === String(_id)

			// ищем запись с таким ID в строкe для рендеринга
			let _found = this.cacheData.some(item => {
				if (String(item['service_id']) === String(_id)) return true
			})

			// если это был ID нашего VDS или бэкапа
			if (_isVds || _found)
				this.requestData()
		},
		//---------------------------------------------------------------------
		// получение статуса
		//---------------------------------------------------------------------
		Status(row) {
			// формируем поле расширенного статуса
			let _field = 'service_status'
			let _extField = 'service_status_text'
			// готовим ответ
			let _answer = {
				'loader': false,
				'timer': false,
				'status': ''
			}

			// сначала проверяем расширенный статус
			if (row[_extField])
			{
				// значение расширенного статуса
				let _extValue = row[_extField].replace('request/status_processing', '').trim()

				// по умолчанию считаем что это проецсс
				_answer['status'] = this.localeFtc(_extValue).toLowerCase()
				_answer['loader'] = true

				// если это очередь
				if (_extValue.indexOf('request/status_queue') > -1)
				{
					_extValue = _extValue.replace('request/status_queue', '').trim()
					_answer['status'] = this.localeFtc(_extValue).toLowerCase()
					_answer['loader'] = false
					_answer['timer'] = true
				}

				return _answer
			}

			// расширенный статус пуст - смотрим на стандартный статус
			if (row[_field] === null || row[_field] === undefined)
			{
				_answer['status'] = 'unknown'
				return _answer
			}

			let _status = row[_field]
			if (_status.indexOf('service/status_') !== 0)
				_status = 'service/status_' + _status

			_answer['status'] = this.localeFtc(_status).toLowerCase()

			// для отдельных случаев требуется лоадер
			if (row[_field] === 'processing') _answer['loader'] = true

			return _answer
		},
		//---------------------------------------------------------------------
		// есть ли видимые поля в строке
		//---------------------------------------------------------------------
		isVisibleField(row) {
			if (!row) return false
			// по умолчанию не видна
			let _answer = false
			// ищем любое поле с типом не "hidden"
			row.some((item, idx, arr) => {
				// если такое поле есть - значит строка должна быть видима
				if (item && item.type !== 'hidden' && item['_visible'] === true)
				{
					_answer = true
					return true
				}
			})

			// возвращаем результат
			return _answer
		},
		//---------------------------------------------------------------------
		// поменялось поле
		//---------------------------------------------------------------------
		fieldChanged(field) {
			this.showif()
			this.reloadif(field['_field_name'])
		},
		//---------------------------------------------------------------------
		// поиск поля в formData
		//---------------------------------------------------------------------
		findField(name) {
			// если нет вообще полей
			if (!this.form || !this.form.fields || !this.form.fields.length) {
				return null
			}

			// поля есть - пробежимся по ним
			let _field = null
			this.form.fields.some(item => {
				if (item && Array.isArray(item))
				{
					item.some(obj => {
						if (obj && obj['_field_name'] === name)
						{
							_field = obj
							return true
						}
					})

					if (_field) return true
				}
			})

			return _field
		},
		//---------------------------------------------------------------------
		// поиск поля в formData
		//---------------------------------------------------------------------
		findFieldByTitleAndType(title, type) {
			// если нет вообще полей
			if (!this.form || !this.form.fields || !this.form.fields.length) {
				return null
			}

			// поля есть - пробежимся по ним
			let _field = null
			this.form.fields.some(item => {
				if (item && Array.isArray(item))
				{
					item.some(obj => {
						if (obj && obj['title'] === title && obj['type'] === type)
						{
							_field = obj
							return true
						}
					})

					if (_field) return true
				}
			})

			return _field
		},
		//---------------------------------------------------------------------
		// обновляем все поля со свойством "reload" = changedFieldName
		//---------------------------------------------------------------------
		reloadif(changedFieldName) {
			// бежим по всем полям
			let _rows = this.form['fields']
			if (!_rows || !Array.isArray(_rows)) return

			// бежим по всем полям - смотрим на свойство "reload"
			_rows.forEach((item) => {
				// смотрим только строки которые определены и являются массивами
				if (item && Array.isArray(item))
				{
					item.forEach((field, idx, arr) => {
						// если нет поля для перезагрузки
						if (!field['reload']) return
						// смотрим только поля с "reload" = changedFieldName
						if (field['reload'] === changedFieldName ||
							(field['reload'].length && field['reload'].indexOf(changedFieldName) !== -1))
						{
							// получим URL
							let _url = field['url']

							// ищем указанное поле
							if (Array.isArray(field['reload']))
							{
								// есть ли пустые значения
								let _isEmptyValue = false
								for (let i = 0; i < field['reload'].length; i++)
								{
									// найдем это поле
									let _ff = this.findField(field['reload'][i])
									// если нашли
									if (_ff)
									{
										// проверим значение
										if (_ff['value'] !== undefined && _ff['value'] !== null && _ff['value'] !== '')
										{
											// подставляем значения в URL
											_url = _url.replace(field['reload'][i] + '=', field['reload'][i] + '=' + _ff['value'])
										}
										// есть хотя бы одно пустое значение (в поле не задано значение)
										else _isEmptyValue = true
									}
									else _isEmptyValue = true
								}
								// если есть поля с незаданными значениями - подгрузка не нужна
								if (_isEmptyValue) return
								// теперь формируем URL окончательно
								_url = this.APIServerUrl + _url
							}
							else
							{
								let _values = []
								let _field = this.findField(field['reload'])
								if (_field && 'value' in _field)
								{
									if (Array.isArray(_field['value'])) _field['value'].forEach((i) => { _values.push(i) })
									else _values.push(_field['value'])
								}
								_url = this.APIServerUrl + _url + _values.join(',')
							}

							// делаем запрос
							if (_url)
							{
								// если уже есть такой запрос - пропускаем
								if (this.reloadifRequests[_url]) return
								// сам запрос
								this.reloadifRequests[_url] = true
								this.$http.get(_url).then(
									// рассматриваем только успешный ответ
									res => {
										// обнулим флаг
										delete this.reloadifRequests[_url]
										// получаем ответ
										let _dt = res && res.data && typeof res.data === 'object' ? res.data : false
										// если ответ корректный - меняем список
										if (_dt && _dt['status'] === 'ok' && _dt['result'] && Array.isArray(_dt['result']))
										{
											// обновляем что нужно обновить
											// для поля типа "list"
											if (field['type'] === 'list')
											{
												// установим полученный список
												this.$set(field, 'list', _dt['result'])
											}
										}
									},
									() => {
										// обнулим флаг
										delete this.reloadifRequests[_url]
									}
								)
							}
						}
					})
				}
			})
		},
		//---------------------------------------------------------------------
		// вычисляем значение "showif" для всех полей
		//---------------------------------------------------------------------
		showif() {
			// бежим по всем полям
			let _rows = this.form['fields']
			if (!_rows || !Array.isArray(_rows)) return

			// готовим объекты, где собираем значения и выражения
			let _values = {}
			let _expressions = {}

			// бежим по всем полям - собираем значения и выражения
			_rows.forEach((item) => {
				// смотрим только строки которые определены и являются массивами
				if (item && Array.isArray(item))
				{
					item.forEach((field, idx, arr) => {
						// смотрим только поля с названиями
						if (field['_field_name'])
						{
							// заполняем объект со значениями
							_values[field['_field_name'].replace(/\[/g, '__').replace(/]/g, '__')] = field['value']

							// если есть выражение для данного поля
							if (field['showif'])
							{
								// получим выражение
								let _expr = field['showif']
								// подменяем в выражении переменные
								if (_expr.indexOf('[') !== -1 && _expr.indexOf(']') !== -1 && _expr.indexOf(' in ') !== -1)
								{
									// условие: var not in [array]
									if (_expr.indexOf(' not in ') !== -1)
									{
										// var not in [1,2,3,4,5] => w5InArray(var, [1,2,3,4,5]) < 0
										let reg = new RegExp(/(\w+) not in (\[[',0-9\s\w]+\])/gi)

										// проверяем
										if (reg.exec(_expr) !== null)
										{
											_expr = _expr.replace(reg, 'w5InArray($1, $2) < 0')
										}
										else
										{
											// var[idx] not in [1,2,3,4,5] => w5InArray(var__idx__, [1,2,3,4,5]) < 0
											reg = new RegExp(/(\w+\[\w+\]) not in (\[[',\w\s]+\])/i)
											let _mtch = null
											if ((_mtch = reg.exec(_expr)) !== null)
											{
												_expr = _expr.replace(_mtch[0], 'w5InArray(' +
													_mtch[1].replace(/\[/g, '__').replace(/]/g, '__') +
													', ' +
													_mtch[2] +
													') < 0')
											}
										}
									}
									// условие: var in [array]
									else
									{
										// var in [1,2,3,4,5] => w5InArray(var, [1,2,3,4,5])
										let reg = new RegExp(/(\w+) in (\[[',0-9\s\w]+\])/gi)

										// проверяем
										if (reg.exec(_expr) !== null)
										{
											_expr = _expr.replace(reg, 'w5InArray($1, $2) !== -1')
										}
										else
										{
											// var[idx] in [1,2,3,4,5] => w5InArray(var__idx__, [1,2,3,4,5])
											reg = new RegExp(/(\w+\[\w+\]) in (\[[',\w\s]+\])/i)
											let _mtch = null
											if ((_mtch = reg.exec(_expr)) !== null)
											{
												_expr = _expr.replace(_mtch[0], 'w5InArray(' +
													_mtch[1].replace(/\[/g, '__').replace(/]/g, '__') +
													', ' +
													_mtch[2] +
													') !== -1')
											}
										}
									}
								}
								// type[period] == 0    =>    type__period__ == 0
								else _expr = _expr.replace(/\[/g, '__').replace(/]/g, '__')
								_expressions[field['_field_name']] = _expr
							}
						}
					})
				}
			})

			// теперь бежим по всем полученным выражениям
			for (let e in _expressions)
			{
				// подменяем поля на свойства объекта
				let _exp = _expressions[e]
				for (let v in _values)
				{
					let reg = new RegExp('\\b' + v + '\\b', 'gi')
					_exp = _exp.replace(reg, (str, offset, src) => {
						// если в начале строки - это точно поле
						if (offset <= 0) return 'obj.' + v
						// если не в начале, и сразу перед ним стоит кавычка - это точно не поле
						else if (src.charAt(offset - 1) === '\'' || src.charAt(offset - 1) === '"') return v
						// по умолчанию это все таки поле
						return 'obj.' + v
					})
				}

				// формируем функцию
				// eslint-disable-next-line
				let _func = new Function('obj', ' return ' + _exp)

				// ищем поле
				let _field = this.findField(e)
				if (_field)
				{
					// обнулим ошибку в любом случае
					this.$set(_field, '_errMsg', '')
					// установим видимость поля
					this.$set(_field, '_visible', _func(_values))
				}
			}
		},
		//---------------------------------------------------------------------
		// локальная проверка полей
		//---------------------------------------------------------------------
		localValidation(field) {
			// проверяем только определенные типы
			// если поле невидно - то и проверять нет смысла, передаваться будет как есть
			if (!field['_visible']) return true
			// если значение поля не задано - то и проверять нет смысла, передаваться будет как есть
			if (field['value'] === undefined || field['value'] === null) return true

			// INTEGRE
			if (field.type === 'integer' || field.type === 'int')
			{
				// получим значение в виде строки
				let v = String(field.value).trim()
				// уберем пробелы
				v = v.replace(/ /g, '')
				// парсим в INT
				let r = parseInt(v)
				// если не удалось
				if (isNaN(r))
				{
					field['_errMsg'] = 'validators/error_int'
					return false
				}

				// если значение не изменилось
				if (v === String(r)) return true
				// значение изменилось
				field['_errMsg'] = 'validators/error_int'
				return false
			}

			// FLOAT || MONEY
			if (field.type === 'float' || field.type === 'money')
			{
				// получим значение в виде строки
				let v = String(field.value).trim()
				// уберем пробелы
				v = v.replace(/ /g, '')
				// парсим в FLOAT
				let r = parseFloat(v)
				// если не удалось
				if (isNaN(r))
				{
					field['_errMsg'] = 'validators/error_float'
					return false
				}

				// доп.проверка
				if (!Helper.isNumeric(String(r)))
				{
					// значение не число
					field['_errMsg'] = 'validators/error_float'
					return false
				}
			}

			// EMAIL
			if (field.type === 'email')
			{
				if (Helper.validateEmail(field.value)) return true
				// проверка не пройдена
				field['_errMsg'] = 'validators/error_email'
				return false
			}

			// для остальных типов все ОК
			return true
		},
		//---------------------------------------------------------------------
		// конвертация данных в FormData
		//---------------------------------------------------------------------
		FD_prepare: function(d, key) {
			let k

			for (k in d) if (d.hasOwnProperty(k))
			{
				// если пересылают файл в форме - патч для safari 10+
				if (d[k] && key &&
					k === 'file' &&
					typeof d[k] === 'object' &&
					'name' in d[k] &&
					'size' in d[k] &&
					'type' in d[k])
				{
					this.FD.append(key + '[' + k + ']', d[k])
					this.FD_count++
					continue
				}

				// остальные поля обрабатываем по старому
				if (typeof d[k] === 'object' && d[k] && !('lastModifiedDate' in d[k]))
				{
					if (key)
					{
						this.FD_prepare(d[k], key + '[' + k + ']')
					}
					else
					{
						this.FD_prepare(d[k], k)
					}
				}
				else
				{
					if (key)
					{
						this.FD.append(key + '[' + k + ']', d[k])
					}
					else
					{
						this.FD.append(k, d[k])
					}

					this.FD_count++
				}
			}
		},
		//---------------------------------------------------------------------
		// форма создания/правки
		//---------------------------------------------------------------------
		// скрыть диалога создания/правки
		hideFormModal(forceClose = true) {
			if (!forceClose)
			{
				// если это просто выход мыши за пределы даилога, например
				// при выделении мышью
				if (!this.maskModalFlag) return
				else if (this.isSliderDraging) return
			}

			EventBus.$emit('w5-body-scroll-enable')
			this.showFormModal = false
			this.hideModalMask()
		},
		// редактирование
		updateForm(id, row) {
			// проверка доступа
			if (!this.Access || this.Error) return
			if (!this.vdsId || !id || !this.isAccess('service/update')) return

			// если идет какой то процесс
			if (row) {
				if (row['Status']['loader'] || row['Status']['timer']) return
			}

			// всегда запрашиваем свежую форму
			this.formMode = 'update'
			this.form = null
			this.formInfo = null
			this.formConfirmText = ''
			this.formId = id
			let _url = this.APIServerUrl + '/service/update/' + id

			this.$http.get(_url)
			.then(
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['status'] === 'form')
					{
						this.form = this.parseFormData(_dt)
						this.$nextTick(() => {
							this.showif()

							// бежим по всем строкам формы
							this.form['fields'].forEach(row => {
								// бежим по всем поля строки
								if (row) row.forEach(fld => {
									this.reloadif(fld['_field_name'])
								})
							})
						})
						// показываем диалог
						EventBus.$emit('w5-body-scroll-disable')
						this.showFormModal = true
					}
				},
				resGet => {
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		// скрытие ненужных полей - которые заполняются данными из VDS
		fillFieldsByValues() {
			// проверка
			if (!this.dc || !this.dc.id) return false

			// ищем нужные поля
			const _dcField = this.findField('datacenter_id')
			if (!_dcField) return false

			// нужно обязательно установить ДЦ таким же как у дс
			_dcField.readonly = true
			_dcField._visible = false
			_dcField.value = String(this.dc.id)

			const _newValue = {
				id: String(this.dc.id),
				name: String(this.dc.name)
			}

			this.$set(_dcField, 'value', String(this.dc.id))
			this.$set(_dcField, 'listValue', _newValue)

			this.$nextTick(() => {
				EventBus.$emit('w5-set-list-field-value', {
					name: 'datacenter_id',
					value: _newValue
				})
			})

			// и сразу скрываем его хедер
			let _dcHeader = this.findFieldByTitleAndType('service/extdisk_location', 'header')
			if (_dcHeader) {
				_dcHeader._visible = false
			}

			// если это сорудник
			if (this.$store.state.user_type === 'admin') {
				if (!this.account || !this.account.account_id || !this.account.account_id.value) return false

				const _accField = this.findField('account_id')
				if (!_accField) return false

				// нужно установить аккаунт и скрыть его
				_accField.readonly = true
				_accField._visible = false
				_accField.value = String(this.account.account_id.value)

				const _newValue = {
					id: String(this.account.account_id.value),
					name: String(this.account.account_name.value)
				}

				this.$set(_accField, 'value', String(this.account.account_id.value))
				this.$set(_accField, 'listValue', _newValue)

				this.$nextTick(() => {
					EventBus.$emit('w5-set-list-field-value', {
						name: 'account_id',
						value: _newValue
					})
				})

				// и сразу скрываем его хедер
				let _dcHeader = this.findFieldByTitleAndType('account/account', 'header')
				if (_dcHeader) {
					_dcHeader._visible = false
				}
			}

			return true
		},
		// создание
		createForm() {
			// проверка доступа
			if (!this.Access || this.Error) return
			if (!this.vdsId || !this.dc || !this.isAccess('service/create')) return

			// всегда запрашиваем свежую форму
			this.form = null
			this.formInfo = null
			this.formMode = 'create'
			this.formConfirmText = ''
			this.formId = null
			let _url = this.APIServerUrl + '/service/create/' + this.diskType

			this.$http.get(_url)
			.then(
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['status'] === 'form')
					{
						// информация
						if (_dt['info']) {
							this.formInfo = _dt['info']
						}
						// все поля
						this.form = this.parseFormData(_dt)

						// инициализация поля размера диска минимумом
						let _quantityField = this.findField('quantity')
						if (_quantityField) {
							if ('min' in _quantityField) {
								_quantityField['value'] = _quantityField.min
							}

							if (this.formInfo && ('cost' in this.formInfo) && !('cost' in _quantityField)) {
								_quantityField['cost'] = this.formInfo.cost
								_quantityField['full_cost'] = this.formInfo.full_cost
								_quantityField['period'] = this.formInfo.period
							}
						}

						this.fillFieldsByValues()

						this.$nextTick(() => {
							this.showif()

							// бежим по всем строкам формы
							this.form['fields'].forEach(row => {
								// бежим по всем поля строки
								if (row) row.forEach(fld => {
									this.reloadif(fld['_field_name'])
								})
							})
						})

						// показываем диалог
						EventBus.$emit('w5-body-scroll-disable')
						this.showFormModal = true
					}
				},
				resGet => {
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		// в форме создания сменили тип диска
		onDiskTypeChanged(value) {
			// перед сменой типа сохраним значения полей
			if (this.form &&
				this.form.fields &&
				this.form.fields.length)
			{
				// сохраним только измененные поля
				this.formSavedFields = null
				const _changedFields = {}
				let _isNeedToSave = false

				for (let _idx in this.form.fields) {
					const _row = this.form.fields[_idx]
					if (!_row || !_row.length) continue

					for (let _jdx in _row) {
						const _field = _row[_jdx]
						if (!_field ||
							!('value' in _field) ||
							_field.type === 'header') {
							continue
						}

						_changedFields[_field._field_name] = _field.value
						_isNeedToSave = true
					}
				}

				if (_isNeedToSave) {
					this.formSavedFields = _changedFields
				}
			}

			// меняем тип
			this.diskType = value

			// запросим форму снова
			let _url = this.APIServerUrl + '/service/create/' + this.diskType

			this.$http.get(_url)
			.then(
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['status'] === 'form')
					{
						// информация
						this.formInfo = null
						if (_dt['info']) {
							this.formInfo = _dt['info']
						}

						this.form = this.parseFormData(_dt)

						// инициализация поля размера диска минимумом
						let _quantityField = this.findField('quantity')
						if (_quantityField) {
							if ('min' in _quantityField) {
								_quantityField['value'] = _quantityField.min
							}

							if (this.formInfo && ('cost' in this.formInfo) && !('cost' in _quantityField)) {
								_quantityField['cost'] = this.formInfo.cost
								_quantityField['full_cost'] = this.formInfo.full_cost
								_quantityField['period'] = this.formInfo.period
							}
						}

						this.fillFieldsByValues()

						// восстановление значений полей после смены типа диска
						if (this.formSavedFields) {
							for (let _key in this.formSavedFields) {
								let _form = this.findField(_key)
								if (_form) {
									_form['value'] = this.formSavedFields[_key]
								}
							}

							this.formSavedFields = null
						}

						this.$nextTick(() => {
							this.showif()

							// бежим по всем строкам формы
							this.form['fields'].forEach(row => {
								// бежим по всем поля строки
								if (row) row.forEach(fld => {
									this.reloadif(fld['_field_name'])
								})
							})
						})

						// показываем диалог
						EventBus.$emit('w5-body-scroll-disable')
						this.showFormModal = true
					}
				},
				resGet => {
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		// старт процесса
		formModalBegin() {
			// проверка доступа
			if (!this.Access || this.Error) return

			// проверка загрузки
			if (this.form_Loading) return

			// если это изменение
			if (this.formMode === 'update') {
				// id диска
				if (!this.formId) return

				// найдем поле с размером диска
				let _quantityField = this.findField('quantity')
				// если увеличили диск
				if (_quantityField && '_oldValue' in _quantityField && 'value' in _quantityField && 'cost' in _quantityField) {
					const _old = parseFloat(_quantityField._oldValue)
					const _new = parseFloat(_quantityField.value)
					const _cost = parseFloat(_quantityField.cost)
					const _attached = Helper.normalizeBooleanValue(_quantityField.attached)

					if (!isNaN(_old) && !isNaN(_new) && !isNaN(_cost) && _old < _new) {
						let _sum = parseFloat((_new - _old).toFixed(2)) * _cost
						let _text = this.localeFtc('service/extdisk_increase_note')
								.replace('{cost}', Helper.FormatMoney2(_sum, 2))
								.replace('{val}', this.localeFtc('main/ruble'))

						if (_attached) {
							_text += '<br><br>\n\n' + this.localeFtc('service/iso_operation_warning')
						}

						this.formConfirmText = _text
						this.formMode = 'updateConfirm'
						return
					}
				}
			}

			// обнулим ошибку
			this.localErrorMessage = ''

			// проверки
			if (!this.vdsId)
			{
				this.localErrorMessage = 'error/app_internal'
				this.hideFormModal()
				return
			}

			// проверка прав доступа
			let _access = true
			if (this.formMode === 'create')
				_access = this.isAccess('service/create')
			else
				_access = this.isAccess('service/update')

			// если доступа нет
			if (!_access)
			{
				this.localErrorMessage = 'main/access_denied'
				this.hideFormModal()
				return
			}

			// обнулим ошибки у скрытых полей
			const _dcField = this.findField('datacenter_id')
			if (_dcField) _dcField['_errMsg'] = ''

			const _accField = this.findField('account_id')
			if (_accField) _accField['_errMsg'] = ''

			// бежим по всем полям
			let _rows = this.form['fields']

			// если полей нет
			if (!_rows || !Array.isArray(_rows))
			{
				this.localErrorMessage = 'error/app_internal'
				this.hideFormModal()
				return
			}

			let _data = this.collectFormData(_rows, this.localValidation, 'disks')
			// если данные по каким либо причинам собрать не удалось
			if (_data === false) return

			// данные собраны - отправляем их
			const _mode = this.formMode === 'create' ? 'create' : 'update'
			let _url = '/service/' + _mode + '/' + (_mode === 'create' ? this.diskType : this.formId)
			this.form_Loading = true

			this.$http.get(this.APIServerUrl + _url)
			.then(resGet => {
				// получаем ответ
				let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
				// если ответ корректный
				if (_dt && _dt['status'] === 'form' && _dt['_csrf'] && _dt['model'])
					return { csrf: _dt['_csrf'], model: _dt['model'] }

				throw new Error(_dt)
			})
			.then(getDate => {
				_data = this.FormDataRePack(_data)

				// готовим данные
				let _post = {
					'_csrf': getDate.csrf
				}
				_post[getDate.model] = _data

				// готовим данные в виде FormData
				this.FD = new FormData()
				this.FD_count = 0
				this.FD_prepare(_post)

				// производим сам запрос
				this.$http.post(this.APIServerUrl + _url, this.FD_count > 0 ? this.FD : null).then(
					// успешный ответ сервера
					resPost => {
						this.form_Loading = false

						// данные
						let _dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
						// если ошибки нет
						if (_dt && _dt['status'] === 'ok')
						{
							let _msg = _mode === 'create' ? 'service/created' : 'service/updated'
							if (_dt.title) _msg = this.localeFtc(_dt.title)

							this.hideFormModal()
							this.$emit('successMessage', _msg)
							this.requestData()
							return
						}

						// если есть ошибки и поля
						if (_dt && _dt['status'] === 'error' && _dt['fields'])
						{
							let _isFieldError = false
							// бежим по всем полям
							for (let k in _dt['fields'])
							{
								if (_dt['fields'][k] && Array.isArray(_dt['fields'][k]) && _dt['fields'][k].length)
								{
									// ищем поле, для которого указана ошибка
									const _fn = k === 'datacenter_id' || 'account_id' ? 'quantity' : k
									let _fld = this.findField(_fn)
									// если такое поле есть - ставим все сообщения
									if (_fld)
									{
										_isFieldError = true
										_fld['_errMsg'] = this.localeFtc(_dt['fields'][k].join(' <br> '))
										EventBus.$emit('w5-set-field-error')
									}
								}
							}
							if (_isFieldError) return
						}

						// иная ошибка
						this.localErrorMessage = this.formatRequestError(resPost)
						this.hideFormModal()
					},
					// отрицательный ответ сервера
					resPost => {
						this.localErrorMessage = this.formatRequestError(resPost)
						this.hideFormModal()
						this.form_Loading = false
					}
				)
			})
			.catch(error => {
				this.localErrorMessage = this.formatRequestError(error)
				this.hideFormModal()
				this.form_Loading = false
			})
		},
		//---------------------------------------------------------------------
		// удаление
		//---------------------------------------------------------------------
		deleteAction(id, row) {
			// проверка доступа
			if (!this.Access || this.Error) return
			// обнулим сообщения
			this.localErrorMessage = ''
			this.deleteModalText = ''
			this.deleteID = null

			// нужно найти запись с данным ID
			let _name = false
			this.cacheData.some(item => {
				if (String(item['service_id']) === String(id))
				{
					_name = this.localeFtc(item['service_name_full'])
					return true
				}
			})

			// если не найден
			if (!_name) return

			// формируем вопрос
			this.deleteModalText = this.localeFtc('service/deleting_backup_confirm')
				.replace('{name}', _name)

			if (row['service_data'] && row['service_data']['extdisk'] && row['service_data']['extdisk']['attached'] === true) {
				this.deleteModalText += '<br><br>' + this.localeFtc('service/iso_operation_warning')
			}

			// закроем все открытые меню
			this.toggleMenu('off')

			// запоминаем ID
			this.deleteID = id
			// таймер
			this.deleteModalTimer = 5
			// можно показывать диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showDeleteModal = true
			// запускаем таймер
			this.deleteModalTimerHandle = setInterval(() => {
				this.deleteModalTimer--
				if (this.deleteModalTimer <= 0)
				{
					clearInterval(this.deleteModalTimerHandle)
					this.deleteModalTimerHandle = false
				}
			}, 1000)
		},
		// установка статуса для записи с заданным ID
		restoreStatus(id, status) {
			this.cacheData.some((item, idx, arr) => {
				if (String(item['service_id']) === String(id))
				{
					arr[idx]['Status'] = status
					return true
				}
			})
		},
		// старт процесса удаления
		deleteBackupBegin() {
			// проверка таймера
			if (this.deleteModalTimer && this.deleteModalTimer > 0) return
			// проверка доступа
			if (!this.Access || this.Error) return
			// обнулим сообщения
			this.localErrorMessage = ''
			// если не задан ID
			if (!this.deleteID) return

			// сразу скрываем диалог
			this.hideDeleteModal()

			// сразу скроем все кнопки
			let _oldStatus = null
			// ищем строку по ID
			this.cacheData.some((item, idx, arr) => {
				if (String(item['service_id']) === String(this.deleteID))
				{
					_oldStatus = item['Status']
					arr[idx]['Status'] = { loader: true, status: this.localeFtc('main/deleting') }
					return true
				}
			})

			// все в порядке - формируем URL
			let _url = this.APIServerUrl + '/service/delete/' + this.deleteID
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// установим успешное сообщение
									this.$emit('successMessage', 'service/extdisk_deleting_begin_process')
									// на этом все
									return
								}

								// вернем значение кнопок
								if (_oldStatus) this.restoreStatus(this.deleteID, _oldStatus)
								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// вернем значение кнопок
								if (_oldStatus) this.restoreStatus(this.deleteID, _oldStatus)
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// вернем значение кнопок
					if (_oldStatus) this.restoreStatus(this.deleteID, _oldStatus)
					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// вернем значение кнопок
					if (_oldStatus) this.restoreStatus(this.deleteID, _oldStatus)
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		// закрытие диалога удаления
		hideDeleteModal() {
			if (this.deleteModalTimerHandle)
			{
				clearInterval(this.deleteModalTimerHandle)
				this.deleteModalTimerHandle = false
			}
			EventBus.$emit('w5-body-scroll-enable')
			this.showDeleteModal = false
			this.hideModalMask()
		},
		//---------------------------------------------------------------------
		// извлечение Внешнего диска из списка (вызов диалога)
		//---------------------------------------------------------------------
		// закрывает диалог извлечения
		hideModal() {
			// если активен таймер блокировки
			if (this.modalTimerHandler)
			{
				clearInterval(this.modalTimerHandler)
				this.modalTimerHandler = null
			}

			EventBus.$emit('w5-body-scroll-enable')
			this.showModal = false
			this.hideModalMask()
		},
		// диалог детача
		ejectOuterDisk(row, e) {
			// проверка ID
			if (!row || !row['service_id'] || !row['service_name'] || !row['parent_id']) return
			// если идет какой то процесс
			if (row && row['service_status_text'] && String(row['service_status_text']).length) return
			// проверка прав
			if (!this.isAccess('service/update')) return
			// прерываем всплытие
			if (e) e.preventDefault()
			if (e) e.stopPropagation()

			// закроем все открытые меню
			this.toggleMenu('off')

			// обнуляем сообщение
			this.localErrorMessage = ''
			// запоминаем ID
			this.formId = row['service_id']
			this.formParentId = row['parent_id']
			// ставим сообщение
			this.modalTitle = 'service/extdisk'
			this.modalText = this.localeFtc('service/extdisk_ejecting_confirm')
				.replace('{disk}', row['service_name'])

			// кнопка диалога
			this.modalTimer = 5
			this.modalButtonTitle = '5 - ' + this.localeFtc('main/detach')

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showModal = true

			// запускаем таймер
			this.modalTimerHandler = setInterval(() => {
				this.modalTimer--
				this.modalButtonTitle = this.modalTimer + ' - ' + this.localeFtc('main/detach')
				if (this.modalTimer <= 0)
				{
					this.modalButtonTitle = this.localeFtc('main/detach')
					clearInterval(this.modalTimerHandler)
					this.modalTimerHandler = null
				}
			}, 1000)
		},
		// диалог подключения диска
		insertDisk(row, e) {
			// проверка ID
			if (!this.vdsId || !row || !row['service_id'] || !row['service_name']) return
			// если идет какой то процесс
			if (row && row['service_status_text'] && String(row['service_status_text']).length) return
			// проверка прав
			if (!this.isAccess('service/update')) return
			// прерываем всплытие
			if (e) e.preventDefault()
			if (e) e.stopPropagation()

			// закроем все открытые меню
			this.toggleMenu('off')

			// обнуляем сообщение
			this.localErrorMessage = ''
			// запоминаем ID
			this.formId = row['service_id']
			// ставим сообщение
			this.modalTitle = 'service/extdisk'
			this.modalText = this.localeFtc('service/extdisk_inserting_confirm <br><br> service/iso_operation_warning')

			// кнопка диалога
			this.modalTimer = 0
			this.modalTimerHandler = null
			this.modalButtonTitle = this.localeFtc('main/attach')

			// показываем диалог
			EventBus.$emit('w5-body-scroll-disable')
			this.showModal = true
		},
		// proxy
		diskProcessBegin(e) {
			if (this.modalButtonTitle === this.localeFtc('main/detach')) {
				this.detachOuterDiskBegin(e)
			} else if (this.modalButtonTitle === this.localeFtc('main/attach')) {
				this.attachOuterDiskBegin(e)
			}
		},
		// непосредственно извлечение внешнего диска
		detachOuterDiskBegin(e) {
			// если таймер еще активен
			if (this.modalTimer > 0)
			{
				if (e) e.preventDefault()
				return
			}

			// проверка ID
			if (!this.formId || !this.formParentId) return
			// проверка прав
			if (!this.isAccess('service/update')) return

			// закроме диалога
			this.hideModal()

			// формируем URL
			let _url = this.APIServerUrl + '/service/update/' + this.formId + '?additional=setDetach'
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									this.$emit('successMessage', _dt['title'] || 'main/process_started')
									// сами рефрешим
									this.requestData()
									// на этом все
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		// непосредственно соединение внешнего диска
		attachOuterDiskBegin(e) {
			// проверка ID
			if (!this.formId || !this.vdsId) return
			// проверка прав
			if (!this.isAccess('service/update')) return

			// закроме диалога
			this.hideModal()

			// формируем URL
			let _url = this.APIServerUrl + '/service/update/' + this.formId + '?additional=setAttach&service_id=' + this.vdsId
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'])
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									this.$emit('successMessage', _dt['title'] || 'main/process_started')
									// сами рефрешим
									this.requestData()
									// на этом все
									return
								}

								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// открытие/закрытие меню строки
		//---------------------------------------------------------------------
		toggleMenu(row) {
			// если требуется закрыть все открытые меню
			if (row === 'off')
			{
				this.cacheData.forEach(item => {
					item['__btnShow'] = false
				})
				return
			}

			// меняем видимость на противоположную в заданой строке
			this.cacheData.forEach(item => {
				if (String(item.service_id) === String(row.service_id))
					item['__btnShow'] = !item['__btnShow']
				else
					item['__btnShow'] = false
			})

			// рассчитаем - куда открывать
			this.UpOrDown(row['service_id'])
		},
		//---------------------------------------------------------------------
		// куда открывать - вверх или вниз
		//---------------------------------------------------------------------
		UpOrDown(id) {
			// по умолчанию стиля нет
			this.cssUl = false

			// находим главный блок
			let _div = $('div[data-id="' + id + '"]')
			if (!_div.length) return

			// в нем находим блок с меню
			let _ul = _div.find('ul:first')
			if (!_ul.length) return

			// находим расположение главного блока и высоты
			let _rect = _div.offset()
			let _heightDiv = _div.height()
			let _heightUl = _ul.height()

			// расчитаем координаты низ блока с меню
			let _bottomUl = _rect.top + _heightDiv + _heightUl + 10 - $(window).scrollTop()
			// если они ниже высоты окна
			if (_bottomUl > window.innerHeight) this.cssUl = 'top: -' + (_heightDiv + _heightUl) + 'px'
		},

		//---------------------------------------------------------------------
		// старт перетаскивания ползунка в сладере
		//---------------------------------------------------------------------
		onDragStart() {
			this.isSliderDraging = true
		},

		//---------------------------------------------------------------------
		// окончание перетаскивания ползунка в сладере
		//---------------------------------------------------------------------
		onDragEnd() {
			this.isSliderDraging = false
		},

		//---------------------------------------------------------------------
		// если кликнули где то в области непосредственно диалога
		//---------------------------------------------------------------------
		onModalMouse(e) {
			const $form = $('#modal-form')
			if ($.contains($form.get(0), e.target)) {
				this.maskModalFlag = false
				return
			}

			if (!this.isSliderDraging) {
				e.preventDefault()
				e.stopPropagation()
			}
			this.maskModalFlag = false
		},

		//---------------------------------------------------------------------
		// может диск быть подключен
		//---------------------------------------------------------------------
		canConnectDisk(row) {
			if (row && row['service_data'] && row['service_data']['extdisk'] && row['service_data']['extdisk']['attached'] === true) return false
			return true
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// наблюдатель
	//=========================================================================
	watch: {
		'active': function() {
			if (this.active)
				this.requestData()
		},
		'access': function(access) {
			this.Access = access
		},
		'parentError': function(value) {
			this.Error = value
		}
	},

	//=========================================================================
	// используемые компоненты
	//=========================================================================
	components: {
		Field
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.w5-tab-table-th-0 {
	width: auto;
}
.w5-tab-table-th-1 {
	width: 150px;
}
.w5-tab-table-th-2 {
	width: 150px;
}
.w5-tab-table-th-3 {
	width: 80px;
	text-align: center;
}
</style>



// WEBPACK FOOTER //
// disk.vue?c5d83eee